import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { getFixedAssets, createFixedAsset } from '../../api/erp';
import { toast } from 'react-toastify';
import BlurredValue from '../../components/common/BlurredValue';

const FixedAssetsPage = () => {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '', asset_code: '', purchase_date: '', purchase_cost: '', useful_life_years: ''
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const data = await getFixedAssets();
      setAssets(data);
    } catch { toast.error('Failed to load assets'); } 
    finally { setLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createFixedAsset(formData);
      toast.success('Asset created');
      setShowModal(false);
      fetchData();
    } catch { toast.error('Failed to create'); }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold">Fixed Assets</h1>
        <button onClick={() => setShowModal(true)} className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded">
          <Plus size={16} /> Register Asset
        </button>
      </div>

      <div className="bg-white rounded shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left">Asset Code</th>
              <th className="px-6 py-3 text-left">Name</th>
              <th className="px-6 py-3 text-left">Purchase Date</th>
              <th className="px-6 py-3 text-right">Cost</th>
              <th className="px-6 py-3 text-right">Book Value</th>
            </tr>
          </thead>
          <tbody>
            {assets.map(a => (
              <tr key={a.id} className="border-t">
                <td className="px-6 py-4">{a.asset_code}</td>
                <td className="px-6 py-4 font-medium">{a.name}</td>
                <td className="px-6 py-4">{new Date(a.purchase_date).toLocaleDateString()}</td>
                <td className="px-6 py-4 text-right"><BlurredValue value={a.purchase_cost} /></td>
                <td className="px-6 py-4 text-right"><BlurredValue value={a.current_book_value} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4">
          <div className="bg-white rounded p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Register Asset</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input placeholder="Asset Code" className="w-full border p-2 rounded" onChange={e => setFormData({...formData, asset_code: e.target.value})} required />
              <input placeholder="Name" className="w-full border p-2 rounded" onChange={e => setFormData({...formData, name: e.target.value})} required />
              <input type="date" className="w-full border p-2 rounded" onChange={e => setFormData({...formData, purchase_date: e.target.value})} required />
              <input type="number" placeholder="Cost" className="w-full border p-2 rounded" onChange={e => setFormData({...formData, purchase_cost: e.target.value})} required />
              <input type="number" placeholder="Useful Life (Years)" className="w-full border p-2 rounded" onChange={e => setFormData({...formData, useful_life_years: e.target.value})} required />
              
              <div className="flex gap-2 justify-end">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 border rounded">Cancel</button>
                <button type="submit" className="px-4 py-2 bg-black text-white rounded">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FixedAssetsPage;
